var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeading2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    fill: "none",
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "#464646",
    rx: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M4.923 17V7.9H6.301V11.8H10.708V7.9H12.086V17H10.708V12.931H6.301V17H4.923ZM13.7547 17V16.012C14.344 15.544 14.9073 15.0717 15.4447 14.595C15.982 14.1183 16.4587 13.6503 16.8747 13.191C17.2993 12.723 17.633 12.268 17.8757 11.826C18.1183 11.3753 18.2397 10.942 18.2397 10.526C18.2397 10.2487 18.192 9.98867 18.0967 9.746C18.0013 9.49467 17.8453 9.29533 17.6287 9.148C17.412 8.992 17.1217 8.914 16.7577 8.914C16.2117 8.914 15.8 9.08733 15.5227 9.434C15.254 9.78067 15.124 10.1967 15.1327 10.682H13.7937C13.8023 10.0407 13.9367 9.50333 14.1967 9.07C14.4653 8.63667 14.8207 8.30733 15.2627 8.082C15.7133 7.85667 16.2203 7.744 16.7837 7.744C17.6417 7.744 18.3263 7.98667 18.8377 8.472C19.3577 8.94867 19.6177 9.616 19.6177 10.474C19.6177 10.9853 19.492 11.4923 19.2407 11.995C18.998 12.4977 18.6773 12.983 18.2787 13.451C17.8887 13.9103 17.4683 14.3437 17.0177 14.751C16.567 15.1583 16.138 15.5267 15.7307 15.856H19.8907V17H13.7547Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeading2);
export default __webpack_public_path__ + "static/media/heading_2.5cab33e58284ac11dc135bf5b2e715fd.svg";
export { ForwardRef as ReactComponent };